import Vue from 'vue';
import Router, { Route } from 'vue-router';
import store from './store';

Vue.use(Router);

const routes = [
  // Mimity app
  {
    path: '/',
    component: () => import('@/views/Mimity/Home.vue'),
  }, {
    path: '/producten',
    component: () => import('@/views/Mimity/Producten.vue'),
  }, {
    path: '/over-ons',
    component: () => import('@/views/Mimity/OverOns.vue'),
  }, {
    path: '/contact',
    component: () => import('@/views/Mimity/Contact.vue'),
  },


  // Password reset
  {
    path: '/beheer/reset-password/:token',
    component: () => import('@/views/Mimity/ResetPassword.vue'),
  },


  // Admin app
  {
    path: '/beheer/dashboard',
    component: () => import('@/views/Admin/Dashboard.vue'),
    meta: { layout: 'admin', auth: true },
  }, {
    path: '/beheer/producten',
    component: () => import('@/views/Admin/Producten.vue'),
    meta: { layout: 'admin', auth: true },
  }, {
    path: '/beheer/producten/nieuw',
    component: () => import('@/views/Admin/NieuwProduct.vue'),
    meta: { layout: 'admin', auth: true },
  }, {
    path: '/beheer/producten/:id',
    component: () => import('@/views/Admin/ProductBewerken.vue'),
    meta: { layout: 'admin', auth: true },
  }, {
    path: '/beheer/vertalingen',
    component: () => import('@/views/Admin/Vertalingen.vue'),
    meta: { layout: 'admin', auth: true },
  },


  // Fallback if page not found
  { path: '*', redirect: '/' },
];

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to: Route, _: Route, next: (to?: string) => void) => {
  const needsAuth       = to.meta.auth as boolean;
  const isAuthenticated = store.getters['auth/isAuthenticated'] as boolean;

  if (needsAuth && !isAuthenticated) {
    return next('/');
  }

  next();
});

export default router;
